import { render, staticRenderFns } from "./TabsImages.vue?vue&type=template&id=66b1621d&scoped=true&"
import script from "./TabsImages.vue?vue&type=script&lang=js&"
export * from "./TabsImages.vue?vue&type=script&lang=js&"
import style0 from "./TabsImages.vue?vue&type=style&index=0&id=66b1621d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b1621d",
  null
  
)

export default component.exports